// Панель вкладок

import type { ReactNode } from 'react';
import './Layout.css';

interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
  description?: string;
}

interface TabPanelProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  children: ReactNode;
}

export function TabPanel({ tabs, activeTab, onTabChange, children }: TabPanelProps) {
  const currentTab = tabs.find(tab => tab.id === activeTab);
  
  return (
    <div className="tabs">
      <div className="tabs__list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tabs__tab ${activeTab === tab.id ? 'tabs__tab--active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
      {currentTab?.description && (
        <div className="tabs__description">
          {currentTab.description}
        </div>
      )}
      <div className="tabs__content">
        {children}
      </div>
    </div>
  );
}
